import { ApolloClient, InMemoryCache, from } from "@apollo/client";

import {
  tokenRefreshLink,
  authLink,
  httpLink,
  retryLink,
  sentryBreadcrumbsLink,
} from "./links";

export const apollo = new ApolloClient({
  // first check for token refresh and update the token stored in local storage
  // then pass to auth link which will use the latest token
  // lastly forward request to apollo http layer
  link: from([
    sentryBreadcrumbsLink,
    retryLink,
    authLink(),
    tokenRefreshLink,
    httpLink,
  ]),
  cache: new InMemoryCache({
    typePolicies: {
      GraphAnalyticMetric: {
        keyFields: false,
      },
    },
  }),
});
